export const freeShippingOfferFor = ({
  country,
  frenchThreshold,
  thresholds,
}) => {
  if (country === 'FR') {
    return frenchThreshold ? { amount: frenchThreshold, relay: false } : null
  }

  return thresholds?.[country] || null
}

export const reachesFreeShipping = (offer, total) =>
  !!offer && Number(total) >= offer.amount

export const freeShippingTitleKey = (namespace, country, offer) => {
  if (country === 'FR') return `${namespace}.freeFrenchShipping`

  return offer?.relay
    ? `${namespace}.freeRelayShipping`
    : `${namespace}.freeShipping`
}
